import QRCode from 'qrcode';

const goTmonUrl = `http://go.tmon.co.kr/?type=deal&srl=${TMON.htStaticData.htDealInfo.dealNo}`;

// PC 앱전용딜 고티몬 QRCode
export function appOnlyQRCode() {
  const qrCodeBox = document.querySelectorAll('.deals-app__img > .qrcode');
  const qrCodeOptions = {
    width: 74,
    height: 74,
  };

  qrCodeBox.forEach((img) => {
    QRCode.toDataURL(goTmonUrl, qrCodeOptions)
    .then(url => {
      img.setAttribute('src', url);
    })
    .catch(error => {
      console.error(error);
    })
  })
}

// 앱전용딜 구매/응모하기 버튼 클릭 이벤트
// 로그인 여부, 옵션 선택 여부와 상관없이 앱으로 이동될 수 있는 팝업을 노출시킵니다.
export function appOnlyPopupEvent () {
  const pcPurchaseArea = $('.wrap_deals_basic');
  const pcGoAppPopup = $('.purchase_list_box > .deals-app');
  const pcBottomPurchaseArea = $('.order_bottom');
  const pcBottomGoAppPopup = $('.order_bottom .deals-app');
  const mwPurchaseArea = $('#prch-controller');
  const mwGoAppPopup = $('section.deals-app');
  pcGoAppPopup.addClass('c-popup--pos-br');
  pcBottomGoAppPopup.addClass('c-popup--pos-bl');

  if(TMON.htStaticData.htDealInfo.isAppOnly) {
    if(TMON.oApp.sPlatform === 'PW') {
      pcPurchaseArea.on('click', 'button[data-role=prchActionBtn]', () => {
        pcGoAppPopup.toggle();
      });
      pcPurchaseArea.on('click', 'button[data-role=appOnlyCloseBtn]', () => {
        pcGoAppPopup.hide();
      });
      pcBottomPurchaseArea.on('click', 'button[data-role=prchActionBtn]', () => {
        pcBottomGoAppPopup.toggle();
      });
      pcBottomPurchaseArea.on('click', 'button[data-role=appOnlyCloseBtn]', () => {
        pcBottomGoAppPopup.hide();
      });
    }

    if (TMON.oApp.sPlatform === 'MW') {
      mwPurchaseArea.on('click', 'button[data-role=openDrawer]', () => {
        mwGoAppPopup.show();
      });
      mwGoAppPopup.on('click', 'a[data-role=appOnlyCloseBtn]', (e) => {
        e.preventDefault();
        mwGoAppPopup.hide();
      });
      mwGoAppPopup.on('click', 'button[data-role=goAppBtn]', () => {
        window.location.replace(goTmonUrl);
      });
    }
  }
}